import type { Ref } from 'react';
import { Search, X } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Узкое поле для плотных панелей (список чатов) */
  compact?: boolean;
  /** Общий поиск в меню ставит сюда курсор по Ctrl+K */
  inputRef?: Ref<HTMLInputElement>;
  onFocus?: () => void;
}

// Одно поле поиска на всю панель: раньше оно было только у нарядов и жило внутри
// OrdersFilterBar. Вынесено, чтобы на всех страницах поиск выглядел и вёл себя одинаково.
export default function SearchInput({ value, onChange, placeholder = 'Поиск...', compact, inputRef, onFocus }: SearchInputProps) {
  return (
    <div className={compact ? 'search-field search-field-compact' : 'search-field'}>
      <Search size={15} />
      <input
        ref={inputRef}
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
      />
      {value && (
        <button type="button" className="search-field-clear" onClick={() => onChange('')} title="Очистить поиск">
          <X size={14} />
        </button>
      )}
    </div>
  );
}
